export default {
    objectIdQueryParameter: "mid",
    dev: {
        isLocal: false
    },
    api: {
        baseUrl: "https://api.dimu.org/",
        baseUrlImage: "https://mm.dimu.org/image/",
        baseUrlNkl: "https://nkl.snl.no/api/v1/search?query=",
        baseUrlSnl: "https://snl.no/api/v1/search?query=",
        baseUrlArtifact: '',
        key: "TXfNazNFTZO0P%2B2lfu9eTg",
        sort: "artifact.uniqueId",
        sortDirection: "asc",
        numberOfElements: 100
    },
    list: {
        numberOfElements: 25
    },
    categories: {
        numberOfElements: 4
    },
    sort: {
        relevance: "relevance",
        titleAsc: "title-asc",
        timeAsc: "time-asc",
        timeDesc: "time-desc",
        artistLastnameAsc: "artist-lastname-asc"
    },
    selectors: {
        numberOfHits: "#",
        category: "[c]",
        search: "[s]"
    },
    search: {
        minimumNumberOfChars: 3
    }
};
